import React, { useState, useEffect } from 'react';
import { Container, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import "./index.css"
import { useTranslation } from "react-i18next";
import ExitModalAndSave from '../Modal/ExitModalAndSave';
import { useHistory } from "react-router-dom";
import RepairJourney from '../RepairJourney';
import * as api from "../../api";
import { useSelector, useDispatch } from 'react-redux';
import { saveHazardType, saveHHSRSOption, saveSaverityScore } from '../../ducks/redux/actions/FinancialReferral';
import { PermissionsList } from '../../models/Permissions';
import { Helper } from '../../utils/Helper/HelperUtil';
import { WorksOrderRequest } from '../../models/WorksOrders/WorksOrderRequest';
import { workOrderRepairObject } from '../../ducks/redux/actions/getAddress';
import { isNullOrUndefined } from '../../utils/formatting';

interface HHSRSProps {
  onChange?: (value: 'yes' | 'no') => void;
}



const HHSRS: React.FC<HHSRSProps> = ({ onChange }) => {
  const [categoryOptions, setCategoryOptions] = useState<{ value: string, label: string }[]>([]);
  const [severityOptions, setSeverityOptions] = useState<{ value: string, label: string }[]>([]);
  const hhsrsOptionFromStore = useSelector((state: any) => state.financialReferralReducer?.saveHHSRSOptionValue);
  const categoryTypeFromStore = useSelector((state: any) => state.financialReferralReducer?.saveHazardType);
  const saverityScoreFromStore = useSelector((state: any) => state.financialReferralReducer?.saveSaverityScore);
  let initialSelected;
  if (hhsrsOptionFromStore === true) {
    initialSelected = 'yes';
  } else {
    initialSelected = 'no';
  }
  const [selected, setSelected] = useState(initialSelected);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(categoryTypeFromStore || null);
  const [selectedSeverity, setSelectedSeverity] = useState<string | null>(saverityScoreFromStore || null);
  const [error, setError] = useState("");
  const userChosenDuplicateQuestion = useSelector((state: any) => state?.userChoicesReducer?.userChosenDuplicateQuestion);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const isEligibleForEnhancedDiagnostics = useSelector((state: any) => state?.addresses?.isEligibleForEnhancedDiagnostics);
  const workOrderObject = useSelector((state: any) => state?.addresses?.workOrderRepair);
  const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
  const choosePriorityOfRepairPermission = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.workorder_choose_priority_of_repair);
  const priorityCodeValue = useSelector((state: any) => state.dashboardReducer?.formState?.priorityCode);


  const callReferenceDataAPI = async () => {
    try {
      const apiResponse = await api.getHHSRSReferenceData();
      if (Array.isArray(apiResponse) && apiResponse.length > 0) {
        const namespaces = apiResponse[0]?.namespaces || [];
        // Find hazard and severity namespaces
        const hazardNs = namespaces.find((item: any) => item.namespace?.name === "repair-hhsrs-category");
        const severityNs = namespaces.find((item: any) => item.namespace?.name === "repair-hhsrs-severity");

        if (hazardNs?.namespace?.keyValues) {
          const hazardArr = Object.entries(hazardNs.namespace.keyValues).map(([key, value]) => ({
            value: value as string,
            label: value as string
          }));
          setSeverityOptions(hazardArr);
        }
        if (severityNs?.namespace?.keyValues) {
          const severityArr = Object.entries(severityNs.namespace.keyValues).map(([key, value]) => ({
            value: value as string,
            label: value as string
          }));
          setCategoryOptions(severityArr);
        }
      }
    } catch (e: any) {
      console.log("Error:", e);
    }
  }

  useEffect(() => {
    //Reference Data API Endpoint
    callReferenceDataAPI();
    // Restore values if coming from next page or edit from summary page
    setSelected(hhsrsOptionFromStore === true ? 'yes' : 'no');
    if (categoryTypeFromStore) setSelectedCategory(categoryTypeFromStore);
    if (saverityScoreFromStore) setSelectedSeverity(saverityScoreFromStore);
  }, []);

  const handleCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    event.target.size = 1;
    event.target.blur();
    setSelectedCategory(value);
    setError("");
  };
  const handleSeverityChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    event.target.size = 1;
    event.target.blur();
    setSelectedSeverity(value);
    setError("");
  };
  const handleContinue = () => {
    dispatch(saveHHSRSOption(selected === "yes"));
    if (selected === 'yes') {
      if (
        (!selectedCategory || selectedCategory === null || selectedCategory === 'none') &&
        (!selectedSeverity || selectedSeverity === null || selectedSeverity === 'none')
      ) {
        setError("Please complete the required HHSRS details: HHSRS Category & HHSRS Severity before continuing.")
        return false;
      } else if (!selectedCategory || selectedCategory === null || selectedCategory === 'none') {
        setError('Please select the HHSRS Category before continuing.');
        return false;
      } else if (!selectedSeverity || selectedSeverity === null || selectedSeverity === 'none') {
        setError('Please select the HHSRS Severity before continuing.');
        return false;
      } else if (workOrderObject?.isEnhancedDiagnosticsRepair && choosePriorityOfRepairPermission && (choosePriorityOfRepairPermission || priorityCodeValue === Helper.RepairPriorityCodes.EME)) {
        RedirectComponent("EDEmegency")
      } else {
        RedirectComponent("/RepairAdditionalDetails");
      }
    } else if (workOrderObject?.isEnhancedDiagnosticsRepair && choosePriorityOfRepairPermission && (choosePriorityOfRepairPermission || priorityCodeValue === Helper.RepairPriorityCodes.EME)) {
      RedirectComponent("EDEmegency")
    } else {
      RedirectComponent("/RepairAdditionalDetails");
    }

  };

  const RedirectComponent = (route:string) => {
    if (error === '') {
      updateWorkOderPatchApi();
      dispatch(saveHHSRSOption(selected === "yes"));
      dispatch(saveHazardType(selectedCategory));
      dispatch(saveSaverityScore(selectedSeverity));
    }
    if(route === "EDEmegency"){
      history.push("/RepairEDEmergency");
    }else{
      history.push("/RepairAdditionalDetails");
    }
  }

  const updateWorkOderPatchApi = async () => {
    try {
      workOrderObject.isHHSRSHazard = selected === 'yes';
      // Remove hhsrsAssessment if it exists and selected is not 'yes'
      if (selected !== 'yes') {
        delete workOrderObject.hhsrsAssessment;
      }
      // Only add hhsrsAssessment if selected is 'yes'
      else if (selected === 'yes') {
        workOrderObject.hhsrsAssessment = {
          category: selectedCategory,
          severity: selectedSeverity
        };
      }
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters = _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      woRequestParameters.isHHSRSHazard = workOrderObject.isHHSRSHazard;
      if (selected === "yes") {
        woRequestParameters.hhsrsAssessment = workOrderObject.hhsrsAssessment;
      }
      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );
      dispatch(workOrderRepairObject(workOrderObject));
    } catch (e) {
      console.error(e);
      history.push("/GenericError");
    }
  }

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    const normalizedValue = value.toLowerCase() as 'yes' | 'no';
    setSelected(normalizedValue);
    setSelectedCategory(null);
    setSelectedSeverity(null);
    dispatch(saveHazardType(""));
    dispatch(saveSaverityScore(""));
    setError('')
    if (onChange) {
      onChange(normalizedValue);
    }
  };

  const backButtonHandler = async () => {
    // Saving all HHSRS selected value in store
    dispatch(saveHHSRSOption(selected === "yes"));
    dispatch(saveHazardType(selectedCategory));
    dispatch(saveSaverityScore(selectedSeverity));
    const isEDRepair = workOrderObject?.isEnhancedDiagnosticsRepair ?? false;
    if (!isNullOrUndefined(userChosenDuplicateQuestion)) {
      history.push("/DuplicateRepair");
    }
    else if (isEligibleForEnhancedDiagnostics && isEDRepair) {
      history.push("/RepairTradeCategory");
    } else {
      history.push("/RepairLocation")
    }
  }

  const exitButtonHandler = () => {
    dispatch(saveHazardType(''));
    dispatch(saveSaverityScore(''));
    history.push("/LandingView");
  };

  const saveDraftAndExit = async () => {
    await updateWorkOderPatchApi();
    history.push(`/WorkOrder360View/${workOrderObject.id}`);
  }

  return (
    <Container id="reploc-container" role="main" className="ctn-fht ">
      <div className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0">
        <div className="back-and-journey">
          <p id="RepairLocation-p" className="text-teal text-xl mt-4 mb-8">
            <button
              className="back-btn"
              data-testid="backButtonHandler"
              onClick={backButtonHandler}
            >
              <i className="fas fa-angle-left mr-2"></i>
              {t("back")}
            </button>
          </p>
          <RepairJourney />
        </div>
        <div className="padding-repair">
          <h1 className="header-size" id="velQues-main-div">
            {t("HHRS")}
          </h1>
        </div>
        <div className="padding-repair mt-4">
          <RadioGroup
            role="radiogroup"
            name="radio-buttons-group"
            key={selected}
            onChange={handleChange}
            value={selected}
          >
            <FormControlLabel
              value="yes"
              control={<Radio id="yes-radio" key="radioYes" />}
              label="Yes"
              className='wid-radio'
              placeholder="Yes"
            />
            <FormControlLabel
              value="no"
              control={<Radio id="no-radio" key="radioNo" />}
              label="No"
              className='wid-radio'
              placeholder="No"
            />
          </RadioGroup>
          {selected === 'yes' && (
            <>
              <div className="mt-3">
                <label htmlFor="hazard-severity-select" className="sub-title">
                  Select the Category:
                </label>
                <div className="mt-3">
                  <select
                    id="hazard-severity-select"
                    className="form-select half-width-dropdown"
                    title="Hazard category"
                    value={selectedCategory ?? ""}
                    onChange={handleCategoryChange}
                    onFocus={e => e.target.size = 6}
                    onBlur={e => e.target.size = 1}
                  >

                    <option value="">Select</option>
                    {severityOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-3">
                <label htmlFor="hazard-type-select" className="sub-title">
                  Select the Severity:
                </label>
                <div className="mt-3">
                  <select
                    id="hazard-type-select"
                    className="form-select half-width-dropdown"
                    title="Hazard severity"
                    value={selectedSeverity??""}
                    onChange={handleSeverityChange}
                    onFocus={e => e.target.size = 6}
                    onBlur={e => e.target.size = 1}
                  >
                    <option value="">Select</option>
                    {categoryOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </>
          )}
        </div>
        {(error !== "") && (
          <div
            data-testid="alert-warning"
            className="error mb-8 mt-4"
            role="alert"
            placeholder="alert-message"
          >
            <div className="w-full px-2 py-2 bg-yellow flex items-center">
              <div className="px-4 pr-8">
                <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
              </div>
              <div className="flex items-center">
                <p
                  data-testid="locatioAlert_0"
                  className="w-full text-left my-2 font-AvantGardeGothic-Md"
                >
                  {error}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Add Continue and exit button */}
      <div
        className="flex justify-between items-center pb-4 md:pb-8 container"
        id="repreason-main-btn"
      >
        <ExitModalAndSave
          id="repreason-exitmodal"
          exit={exitButtonHandler}
          saveDraftAndExit={saveDraftAndExit}
        />
        <div className="col-md-12 marginTop-auto mt-4 mb-4">
          <div className="row m-0 footer-actionbtn">
            <div className="col text-end padding-repair">
              <button
                className="button-class"
                id="btn_hhrs_continue"
                onClick={handleContinue}
              >
                {t("continue")}
                <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* End button */}

    </Container>
  );
};

export default HHSRS;
